// import debounce from './global/debounce';
// import Animations from './global/animations';
import schemaFeq from './blocks/schema-feq';
import serviceSlider from './blocks/service-slider';
import initMap from './components/initMap';
import MobileMenu from './global/mobileMenu';
import testimonialsSlider from './blocks/testimonials-slider';
import infogallerySlider from './blocks/info-with-gallery';
import archiveServices from './blocks/archive-services/archive-services';
import header from './header/header';
import footerMenu from './components/footerMenu';
import tracking from './global/tracking';
import forms from './components/forms';
import quoteTool from './quote-tool/quoteTool';
import appointmentTool from './appointment-tool/appointment-tool';
import cancelAppointment from './cancelAppointment';
import customFileUpload from './components/customFileUpload';
import ai from './global/ai';
import aiVin from './global/aiVin';
import aiKm from './global/aiKm';
import checkGarageStatus from './components/garageStatus';
import faq from './components/faq';
import blogArchive from './blocks/blog-archive';
import relatedPostsSlider from './blocks/related-posts-slider';
import promoPopup from './components/promoPopup';

//Wondercontest
import wonderFaq from './wondercontest/faq';
import {
    addressAutocomplete,
    copyLink,
    FormModals,
    handleFormStatus,
    handleSponsors,
    heroName,
    rulesDeepLink,
    garagePreselect,
    enhancedSelects,
} from './wondercontest/form';
import sponsorConfirm from './wondercontest/sponsor';
import contact from './components/contact';
import garageLocator from './quote-tool/modules/garageLocator';

const $ = jQuery;

// Rest of the functions are in mena-core.js. If you need them extract them to a separate file.
document.addEventListener('DOMContentLoaded', () => {
    tracking();
    header();
    MobileMenu();
    serviceSlider();
    testimonialsSlider();
    infogallerySlider();
    forms();
    customFileUpload();
    contact();

    if ($('.schema-faq-section').length > 0) {
        schemaFeq();
    }

    if ($('section.info').length > 0) {
        let latLng = menaObject.latLng;

        if ($('.js-single-garages--coords').length > 0) {
            latLng['lat'] = $('.js-single-garages--coords').data('lat');
            latLng['lng'] = $('.js-single-garages--coords').data('lng');
        }

        initMap(latLng);
    }

    if ($('.archive-services').length > 0) {
        archiveServices();
    }

    if ($('.blog-archive').length > 0) {
        blogArchive();
    }

    if ($('.js-related-posts-slider').length > 0) {
        relatedPostsSlider();
    }

    if ($('#quote-tool').length > 0) {
        quoteTool();
    }

    if ($('#appointment-tool').length > 0) {
        appointmentTool();
    }

    if ($('.footer__col--services').length > 0) {
        footerMenu();
    }

    if ($('.page-template-cancel-appointment').length > 0) {
        cancelAppointment();
    }

    //Wondercontest
    wonderFaq();
    FormModals();
    rulesDeepLink();
    garagePreselect();
    enhancedSelects();
    addressAutocomplete();
    handleFormStatus();
    handleSponsors();
    heroName();
    copyLink();
    sponsorConfirm();

    //if .c-modal--dashboaord exists
    if ($('.c-modal--dashboard').length > 0) {
		ai();
	}

    //if .c-modal--vin exists
    if ($('.c-modal--vin').length > 0) {
		aiVin();
    }

    //if .c-modal--km exists
    if ($('.c-modal--km').length > 0) {
        aiKm();
    }

    let pageGarageLocator = document.querySelector('.page-template-garage-locator');

	if (pageGarageLocator) {
		garageLocator();
	}

    checkGarageStatus();
    faq();
    promoPopup();
});
